import { apiService } from "../apiServices";
import config from "../../../config/domain";
import servicesList from "../serviceList";
import GlobalStore from "../../store/globalStore";

export const AGetCities = (callback: CallableFunction) => {
  // ToDo: Remove commented code once testing is done for
  // apiService(
  //     {
  //         url: 'eco/get-city',
  //         method: 'GET',
  //     },
  //     callback
  // );

  apiService(
    {
      url: "MastersData/GetCity",
      method: "GET",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: false,
      serviceName: servicesList.getCities,
    },
    callback
  );
};

export const AGetEmailOtp = (callback: CallableFunction, emlObj: any) => {
  apiService(
    {
      url: "DIYAPI/SendOTPonMail",
      body: {
        MailTo: emlObj.mailTo,
        MailFrom: emlObj.mailFrom,
        MailSubject: emlObj.mailSubject,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getOtp,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/send-otp-on-email",
  //     body: emlObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const AGetOtpNew = (callback: CallableFunction, contactInfo: number | string, mode?: any) => {
  const staticKey = "NBA5qJOz6Ll2eWlTvah04dKUe7d3spEq$$$$"
  apiService(
    {
      // url: "Lead/GO",
      url: "Lead/v2/leadcheck",
      body: {
        contactInfo: contactInfo,
        mode: mode
      },
      encryption: true,
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getOtpNew,
      encryptToken: staticKey + contactInfo
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/send-otp-on-email",
  //     body: emlObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AGetMobileOtp = (callback: CallableFunction, mobNo: string) => {
  apiService(
    {
      url: "DIYAPI/GetOTP",
      body: {
        MobNo: mobNo,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: false,
      serviceName: servicesList.getOtp,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/getotp",
  //     body: {
  //       mobNo: mobNo,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AValidateEmailOtp = (
  callback: CallableFunction,
  email: string,
  otp: string
) => {
  apiService(
    {
      url: "DIYAPI/ValidateEmailOTP",
      body: {
        EmailId: email,
        Otp: otp,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.validateOtp,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/validateemailotp",
  //     body: {
  //       email: email,
  //       otp: otp,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AValidateMobileOtp = (
  callback: CallableFunction,
  mobNo: string,
  otp: string
) => {
  apiService(
    {
      url: "DIYAPI/ValidateOTP",
      body: {
        MobNo: mobNo,
        Otp: otp,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: false,
      serviceName: servicesList.validateOtp,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/validateotp",
  //     body: {
  //       mobNo: mobNo,
  //       otp: otp,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const AValidateOtpNew = (
  callback: CallableFunction,
  otpId: any,
  otp: string
) => {
  apiService(
    {
      url: "Lead/ValO",
      body: {
        otpId: otpId,
        otp: otp,
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.validateOtpNew,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/validateotp",
  //     body: {
  //       mobNo: mobNo,
  //       otp: otp,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AGetEmployeeDetails = (
  callback: CallableFunction,
  bodyParams: any
) => {
  apiService(
    {
      url: "RegistrationStage/SearchSource",
      body: {
        UserName: bodyParams.username,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getEmployeeDetails,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-employee-details",
  //     body: bodyParams,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const ASearchLeadByName = (callback: CallableFunction, leadObj: any) => {
  apiService(
    {
      url: "Lead/v1/Search",
      body: {
        AssignedTo: leadObj.assignedTo,
        FirstName: leadObj.firstName,
        LastName: leadObj.lastName,
        Mobile: leadObj.mobile,
        EmailId: leadObj.emailId,
        ProductCode: leadObj.productCode,
        SearchBy: "CRITERIA_MOBILE_EMAIL",
        source: "DIY",
        entityType: GlobalStore?.entityType || "",
        entitySubType: GlobalStore?.entitySubType || "",
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.searchLeadByName,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/search-lead-by-name",
  //     body: leadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const ASearchLeadByNameV2 = (callback: CallableFunction, leadObj: any) => {
  apiService(
    {
      url: "Lead/v2/Search",
      body: {
        AssignedTo: leadObj.assignedTo,
        FirstName: leadObj.firstName,
        LastName: leadObj.lastName,
        Mobile: leadObj.mobile,
        EmailId: leadObj.emailId,
        ProductCode: leadObj.productCode,
        SearchBy: "CRITERIA_MOBILE_EMAIL",
        source: "DIY",
        entityType: GlobalStore?.entityType || "",
        entitySubType: GlobalStore?.entitySubType || "",
        IsOtc: GlobalStore.isOTCFlow,
        countryPrefix: GlobalStore.user.countryCode
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.searchLeadByName,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/search-lead-by-name",
  //     body: leadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const ACreateLead = (callback: CallableFunction, leadObj: any) => {
  apiService(
    {
      url: "eco/create-lead",
      body: leadObj,
      method: "POST",
    },
    callback
  );
};

export const ACreateLeadSource = (callback: CallableFunction, leadObj: any) => {
  // debugger
  console.log("ssss===========", leadObj);
  
  apiService(
    {
      url: "Lead/Create",
      body: {
        Email: leadObj.email,
        FirstName: leadObj.firstName,
        MiddleName: leadObj.middleName || "",
        LastName: leadObj.lastName,
        Phone: leadObj.phone,
        countryPrefix: leadObj.countryPrefix,
        countryShortCode: leadObj.countryShortCode,
        countryName: leadObj.countryName,
        City: leadObj.city,
        AssignedTo: leadObj.assignedTo,
        UtmAdGroup: leadObj.utm_adgroup,
        UtmCampaign: leadObj.utm_campaign,
        UtmContent: leadObj.utm_content,
        UtmCreative: leadObj.utm_creative,
        UtmDevice: leadObj.utm_device,
        UtmMedium: leadObj.utm_medium,
        UtmPlacement: leadObj.utm_placement,
        UtmSource: leadObj.utm_source,
        UtmTerm: leadObj.utm_term,
        ProductCode: leadObj.productCode,
        SourceId: leadObj.sourceId,
        SubSourceId: leadObj.subSourceId,
        ByPassDedupe: leadObj.byPassDedupe,
        RmCode: leadObj.rmCode,
        SourceName: leadObj.sourceName,
        SubSourceName: leadObj.subSourceName,
        accType: leadObj?.accType == "RMINV" ? "RMINV" : "",
        isEmailVerified: leadObj?.isEmailVerified,
        isMobileVerified: leadObj?.isMobileVerified,
        IsRM: leadObj?.IsRM,
        entityType: GlobalStore?.entityType || "",
        entitySubType: GlobalStore?.entitySubType || "",
        IsOtc: GlobalStore.isOTCFlow
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.createLead,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/create-lead-source",
  //     body: leadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const AGetEmailFromCIBIL = (callback: CallableFunction, leadObj: any) => {
  apiService(
    {
      url: "Lead/CBD",
      body: {
        firstname: leadObj?.firstName?leadObj?.firstName:"",
        middlename: "",
        lastname: leadObj?.lastName?leadObj?.lastName:"",
        mobilenumber: leadObj?.mobilenumber?leadObj?.mobilenumber:""
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.getEmailCIBIL,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/create-lead-source",
  //     body: leadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const ALeadFetchApi = (callback: CallableFunction, leadObj: any) => {
  apiService(
    {
      url: "Lead/ExternalDetail",
      body: {
        id: leadObj?.id,
        name: leadObj?.name,
        stageFlag: leadObj?.stageFlag
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.fetchLeadInfo,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/create-lead-source",
  //     body: leadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AEmailUpdateApi = (callback: CallableFunction, leadObj: any) => {
  apiService(
    {
      url: "Lead/EmailUpdate",
      body: {
        emailId: leadObj?.emailId,
        uccCode: leadObj?.uccCode,
        source: leadObj?.source,
        ApplicationId: leadObj?.ApplicationId
      },
      method: "POST",
      apiBaseUrl: config.aopNewApiUrl,
      tempToken: false,
      serviceName: servicesList.emailUpdate,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/create-lead-source",
  //     body: leadObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AWhatsappNotify = (callback: CallableFunction, req: any) => {
  apiService(
    {
      url: "WhatsUpAppService/WhatsUpAppConsent",
      body: {
        Type: req.type,
        recipients: req.recipients,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: false,
      serviceName: servicesList.whatsUpAppConsent,
    },
    callback
  );
  // apiService(
  //   {
  //     apiBaseUrl: config.javaComUrl,
  //     url: "consent",
  //     body: req,
  //     method: "POST",
  //     headers: {
  //       mwAuth: config.whatsappBearerToken,
  //     },
  //   },
  //   callback
  // );
};

export const CreateUCCRegCode = (callback: CallableFunction, req: any) => {
  console.log("REQ||", req);
  apiService(
    {
      url: "Lead/CreateURCode",
      body: req,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: false,
      serviceName: servicesList.createUCCRegCode,
    },
    callback
  );
};
